import React, { Component } from 'react';
import { Row, Col, Tag } from 'antd';
import { Menu as MenuApi, Customer } from '../../../../services/api';
import Week from './Week';
import SaveMenu from '../menu/SaveMenu';
import Spinner from '../../../../components/Spinner';

export default class CustomerMenu extends Component {
    constructor(props) {
        super(props);

        this.state = {
            menu: { tags: [] },
            customer: {},
            menus: [],
            loading: {
                menu: false,
                customer: false
            }
        };
    
        this.menuApi = new MenuApi(props);
        this.customerApi = new Customer(props);
    }

    componentDidMount() {
        this.fetchCustomer();
        this.fetchMenu();
    }

    fetchCustomer = () => {
        const { loading } = this.state;
        const state = this.props.location.state;

        if (state && state.customer) {
            this.setState({ customer: state.customer });
            if (state && state.menus) {
                this.setState({ menus: state.menus });
            } else {
                this.listMenus();
            }
            return;
        }

        loading.customer = true;
        this.setState({ loading });
        this.customerApi.me()
            .then(res => {
                this.setState({ customer: res.data.data });
                this.listMenus();
            })
            .catch(_ => {
                this.customerApi.retry({ cb: this.fetchCustomer });
            });
    }

    listMenus = () => {
        const { customer, loading } = this.state;
        
        this.customerApi.raw().get(customer._links.menus.href)
            .then(res => {
                loading.customer = false;
                this.setState({ loading, menus: res.data.data });
            })
            .catch(_ => {
                this.customerApi.retry({ cb: this.listMenus });
            });
    }

    fetchMenu = () => {
        const { loading } = this.state;
        loading.menu = true;
        this.setState({ loading });

        this.menuApi.find(this.props.match.params.menuId)
            .then(res => {
                loading.menu = false;
                this.setState({ loading, menu: res.data.data });
            })
            .catch(_ => {
                this.menuApi.retry({ cb: this.fetchMenu });
            });
    }

    menuAdded = (customerMenu) => {
        const { menu, customer, menus } = this.state;
        customerMenu.origin = menu;
        this.props.history.push({
            pathname: `/customers/${customer.id}/menus/${menu.id}`,
            state: { menu: customerMenu, customer, menus }
        });
    }

    render() {
        const { menu, loading, menus, customer } = this.state;

        return (
            <Row>
                <Col sm={24} md={18} lg={20}>
                    <h2 style={{ fontSize: '30px', marginBottom: '5px' }}>{menu.title}</h2>
                    <div style={{margin: '10px 0 20px 0' }}>
                        {menu.tags && menu.tags.map(t => (
                            <Tag key={t} color="volcano">{t}</Tag>
                        ))}
                    </div>
                </Col>
                    
                <Col sm={24} md={6} lg={4}>
                    <SaveMenu 
                        className="menu-action-btn"
                        exists={menus.findIndex(m => m.origin.id === menu.id) !== -1}
                        menu={menu}
                        allocatedWeeks={menus.map(m => m.weeks)}
                        customer={customer}
                        onSave={this.menuAdded}
                    />
                </Col>
                <Col span={24}>
                    <Spinner loading={loading.menu} />
                    <Week menu={menu} loading={loading.menu} />
                </Col>
            </Row>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/dashboard/components/menu/Menu.js